import { httpClient } from '@/utils/httpClient';
import { buildParentIdSet } from '@/utils/catalogUtils';

export interface CatalogRow {
  id: string;
  display_name: string;
  entity_identifier: string;
  status: string;
  entity_data: {
    nsn?: string;
    lin?: string;
    unit_price?: number;
    type?: string;
  };
}

class CatalogService {
  private async listAll(): Promise<CatalogRow[]> {
    return httpClient.getAll<CatalogRow>(
      `/api/v1/entities?entity_type=eq.catalog&select=id,display_name,entity_identifier,status,entity_data&order=display_name.asc`,
    );
  }

  async listNonBuy(): Promise<CatalogRow[]> {
    const rows = await this.listAll();
    const parentIds = buildParentIdSet(rows);
    return rows.filter((r) => {
      const isBuyProgram = (r.entity_data.type || '').toLowerCase() === 'buy program';
      const isRetired = (r.status || '').toLowerCase() === 'retired';
      return !isBuyProgram && !parentIds.has(r.id) && !isRetired;
    });
  }

  async listMaintenanceEligibleCatalogIds(): Promise<string[]> {
    const rows = await this.listAll();
    const parentIds = buildParentIdSet(rows);

    return rows
      .filter((row) => {
        const normalizedType = (row.entity_data.type ?? 'stock').toLowerCase().trim();
        return normalizedType === 'stock' && !parentIds.has(row.id);
      })
      .map((row) => row.id);
  }
}

export const catalogService = new CatalogService();
